/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
query VendorReadQuery($vendorId: ID!) {
  VendorRead(vendorId: $vendorId, returnDeliveriesOfTrunk: false) {
    status,
    AccountLogin {
      id
    }
  }
}
`
